import { CommonModule } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShiftGroupformComponent } from '../shift-groupform/shift-groupform.component';
import { ShiftGroupService } from '../../../Model/ShiftGroup/shift-group.service';
import * as XLSX from 'xlsx';
import { SessionService } from '../../../Util/Session/session.service';
import { UploadFormComponent } from '../../../Component/Upload/upload-form/upload-form.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { LoaderComponent } from "../../../Component/Loader/loader/loader.component";

@Component({
  selector: 'app-shift-group',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, LoaderComponent],
  templateUrl: './shift-group.component.html',
  styleUrl: './shift-group.component.scss'
})
export class ShiftGroupComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  ExcelHeaders = [{
    ESS_ExcelUploadMasterID: 1,//ShiftGroupMaster
    Headers: ['ESS_ShiftGroupMasterID', 'ShiftGroupName'],
  }];
  isDisabled: boolean = false;
  uploadfile = null as any;
  excelcheck = false;
  allowsubmit = false;
  dtTrigger: Subject<any> = new Subject<any>();
  Shift: any[] = [];
  ShiftGroupData: any[] = []
  excelResult = [] as any;

  ShiftGroupRecord: any[] = []
  private modalService = inject(NgbModal);
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private toast: ToastService,
    private download: DownloadSampleService,
    private shift: ShiftGroupService,
    private Session: SessionService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  public User: any = null
  filter = {
    SelectType: 'S',
    ESS_ShiftGroupMasterId: 0
  }

  ngOnInit(): void {
    this.GetData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  add(id: number) {
    if ((this.common.PageRight.IsAdd && id == 0) || (this.common.PageRight.IsEdit && id > 0)) {
      const modalRef = this.modalService.open(ShiftGroupformComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.id = id;

      modalRef.result.then((result: any) => {
        if (result) {
          this.GetData();
        }
      }).catch(() => {
        // Modal dismissed
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  GetData() {
    this.isDisabled = true;
    this.shift.ESS_ShiftGroupMaster(this.filter).subscribe({
      next: (response) => {
        this.Shift = Object.values(response.Table);
        this.isDisabled = false;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'ShiftGroupMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.ShiftGroupData = data;
        if (this.ShiftGroupData.length > 0) {
          this.download.exportToExcel(this.ShiftGroupData, "ShiftGroup_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }

  handleFileInput(event: any): void {
    this.ShiftGroupRecord = [];
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  // processExcelFile(file: File): void {
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     if (event && event.target && event.target.result) {
  //       const binaryString = event.target.result as string;
  //       const workbook = XLSX.read(binaryString, { type: 'binary' });
  //       const sheetName = 'Sheet1';
  //       if (!workbook.SheetNames.includes(sheetName)) {
  //         const errorMessage = 'Sheet1 not found in the uploaded file.';
  //         this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
  //         return;
  //       }
  //       const worksheet = workbook.Sheets[sheetName];
  //       const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
  //       const headerRow = excelData[0];
  //       const headers = headerRow.map((header: string) => header.trim());
  //       const dataRows = excelData.slice(1);

  //       const uniqueshiftgroupIds: Set<number> = new Set();
  //       const shiftgroupNames: Set<string> = new Set();
  //       this.ShiftGroupRecord = [];

  //       for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
  //         const row = dataRows[rowIndex];
  //         const rowData: any = {};

  //         row.forEach((cellData, index) => {
  //           rowData[headers[index]] = cellData;
  //         });

  //         const id = rowData['ESS_ShiftGroupMasterID'];
  //         let shiftgroupName = rowData['ShiftGroupName'].toString();

  //         shiftgroupName = shiftgroupName ? shiftgroupName.trim() : '';

  //         if (id !== 0 && id !== '' && id !== undefined && uniqueshiftgroupIds.has(id)) {
  //           this.toast.show({ message: `Duplicate ESS_ShiftGroupMaster ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
  //           return;
  //         } else {
  //           uniqueshiftgroupIds.add(id);
  //         }

  //         if (shiftgroupName === '' || shiftgroupName === null || shiftgroupName === undefined) {
  //           this.toast.show({ message: `Shift group name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
  //           return;
  //         }
  //         else if (shiftgroupNames.has(shiftgroupName)) {
  //           this.toast.show({ message: `Duplicate Shift Group Name "${shiftgroupName}" found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
  //           return;
  //         } else {
  //           shiftgroupNames.add(shiftgroupName);
  //         }
  //         rowData['ShiftGroupName'] = shiftgroupName;
  //         this.ShiftGroupRecord.push(rowData);
  //         console.log(this.ShiftGroupRecord)
  //       }
  //       this.BulkInsertUpdate(this.ShiftGroupRecord);
  //     } else {
  //       console.error('Failed to read the file.');
  //     }
  //   };
  //   reader.readAsBinaryString(file);
  // }
  // BulkInsertUpdate(Data: any) {
  //   this.User = this.Session.GetUserDetails();
  //   if (this.ShiftGroupRecord.length === 0) {
  //     this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
  //     return
  //   }
  //   const shiftgroupData = {
  //     SelectType: 'UPLOAD',
  //     ESS_ShiftGroupMasterInsert: Data,
  //     UserID: this.User.UserId,
  //   };
  //   this.shift.ESS_ShiftGroupMaster_BulkInsert(shiftgroupData).subscribe(
  //     data => {
  //       if (data.Error_Code == '01') {
  //         this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
  //       }
  //       else {
  //         this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
  //       }
  //       this.GetData();
  //     },
  //     error => {
  //       console.error('Error:', error);
  //     });
  // }

  downloadExcel() {
    this.download.downloadExcel('ShiftGroupMaster');
  }

  // upload() {
  //   const modalRef = this.modalService.open(UploadFormComponent, { centered: true, backdrop: 'static', size: 'xl' });

  //   modalRef.result.then((result) => {
  //     if (result) {

  //     }
  //   }).catch((reason) => {
  //     console.log('Modal dismissed:', reason);
  //   });
  // }


  uploadfileData() {
    const file: File = this.uploadfile;
    const fileType: string | undefined = file.name.split('.').pop();
    if (fileType !== 'xlsx' && fileType !== 'xls') {
      this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
      return;
    }
    this.processExcelFile(file);
  }

  processExcelFile(file: File): void {
    this.isDisabled = true;
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        if (excelData.length > 1) {
          const headerRow = excelData[0];
          const headers = headerRow.map((header: string) => header.trim());
          this.allowsubmit = false;
          this.excelcheck = true;

          if (this.ExcelHeaders.length > 0) {
            this.ExcelHeaders[0].Headers.forEach(element => {
              if (this.excelcheck) {
                if (headers.findIndex(e => this.common.ToLowerCase(e) == this.common.ToLowerCase(element)) >= 0) {
                  this.excelcheck = true;
                } else {
                  this.excelcheck = false;
                }
              }

              if (!this.excelcheck) {
                return;
              }
            });
          }

          if (!this.excelcheck) {
            this.reset();
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Excel file column not match. please check sample file";
            modalRef.result.then((result: any) => { });
          } else {
            this.allowsubmit = true;
            this.submit(excelData);
          }
          this.isDisabled = false;
        } else {
          this.reset();
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Excel file have a no data";
          modalRef.result.then((result: any) => { });
        }
      } else {
        console.error('Failed to read the file.');
        this.isDisabled = false;
      }
    };
    reader.readAsBinaryString(file);
  }

  reset() {
    this.isDisabled = false;
    this.allowsubmit = false;
    this.excelResult = [];
    this.removeFile();
  }

  removeFile() {
    this.setallowsubmit();
    this.uploadfile = null;
  }

  setallowsubmit() {
    this.allowsubmit = false;
  }

  handleFileInputChange(event: any): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadfile = file;
      input.value = '';
    } else {
      this.uploadfile = null;
      console.log('No file selected or file selection cancelled');
    }
  }

  submit(excelDatas: any) {
    if (this.allowsubmit) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to submit?';
      modalRef.result.then(async result => {
        if (result) {
          const excelHeader = excelDatas[0];
          const excelData = excelDatas.slice(1);
          this.isDisabled = true;
          for (const element of excelData) {
            if (element[excelHeader.findIndex((e: any) => e.trim() == this.ExcelHeaders[0].Headers[1].trim())] != null && element[excelHeader.findIndex((e: any) => e.trim() == this.ExcelHeaders[0].Headers[1].trim())] != '') {
              await this.SaveFromExcel(
                element[excelHeader.findIndex((e: any) => e.trim() == this.ExcelHeaders[0].Headers[0].trim())],
                element[excelHeader.findIndex((e: any) => e.trim() == this.ExcelHeaders[0].Headers[1].trim())]
              );
            } else {
              this.excelResult.push(
                {
                  [this.ExcelHeaders[0].Headers[0]]: element[excelHeader.findIndex((e: any) => e.trim() == this.ExcelHeaders[0].Headers[0].trim())],
                  [this.ExcelHeaders[0].Headers[1]]: element[excelHeader.findIndex((e: any) => e.trim() == this.ExcelHeaders[0].Headers[1].trim())],
                  Result: "Site group blank not allow"
                }
              );
            }
          }
          this.download.exportToExcel(this.excelResult, "ShiftGroup_Result");
          this.reset();
          this.GetData();
        }
      });
    }
  }

  async SaveFromExcel(ESS_ShiftGroupMasterId: number, ShiftGroupName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.shift.ESS_ShiftGroupMaster_Insert({
        SelectType: (ESS_ShiftGroupMasterId > 0)?'Update':'Insert',
        ESS_ShiftGroupMasterId: ESS_ShiftGroupMasterId,
        ShiftGroupName: ShiftGroupName,
      }).subscribe({
        next: (response) => {
          this.excelResult.push(
            {
              [this.ExcelHeaders[0].Headers[0]]: ESS_ShiftGroupMasterId,
              [this.ExcelHeaders[0].Headers[1]]: ShiftGroupName,
              Result: response.Error_Message
            }
          );
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }
}
